import { Routes } from "@angular/router";
import { AuthGuard } from "../../core/guards/auth-guard.service";
import { PermissionGuard } from "@core/guards/permission.guard";

export const vacacionesRoutes: Routes = [
  {
    path: "vac_inicio",
    loadComponent: () =>
      import("./components/inicio-vacaciones/inicio-vacaciones.component").then(
        (m) => m.InicioVacacionesComponent
      ),
    data: {
      label: "Inicio",
      icon: "home",
      urlexterna: "VAC",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "vac_calendario",
    loadChildren: () =>
      import("./components/calendario-vac/calendario-vac.routes").then(
        (m) => m.calendarioVacRoutes
      ),
    data: {
      label: "Calendario",
      icon: "calendar_month",
      urlexterna: "VAC",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "vac_solicitud",
    loadComponent: () =>
      import(
        "./components/solicitud-vacaciones/solicitud-vacaciones.component"
      ).then((m) => m.SolicitudVacacionesComponent),
    data: {
      label: "Solicitud-vacaciones",
      icon: "post_add",
      urlexterna: "VAC",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "vac_importacion",
    loadChildren: () =>
      import(
        "./components/importacion-vacaciones/importacion-vacaciones.routes"
      ).then((m) => m.importacionVacacionesRoutes),
    data: {
      label: "Importacion-vacaciones",
      icon: "upload_file",
      urlexterna: "VAC",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "vac_gestion",
    loadChildren: () =>
      import("./components/gestion-vacaciones/gestion-vacaciones.routes").then(
        (m) => m.gestionVacacionesRoutes
      ),
    data: {
      label: "Gestion-vacaciones",
      icon: "manage_accounts",
      urlexterna: "VAC",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "vac_consultas",
    loadComponent: () =>
      import("./components/consulta/consulta.component").then(
        (m) => m.ConsultaComponent
      ),
    data: {
      label: "Consulta",
      icon: "list_alt",
      urlexterna: "VAC",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "vac_asignacion",
    loadComponent: () =>
      import("./components/procesos/procesos.component").then(
        (m) => m.ProcesosComponent
      ),
    data: {
      label: "Asignación",
      icon: "assignment_turned_in",
      urlexterna: "VAC",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "vac_antiguedad",
    loadComponent: () =>
      import("./components/antiguedad/antiguedad.component").then(
        (m) => m.AntiguedadComponent
      ),
    data: {
      label: "Antigüedad",
      icon: "fact_check",
      urlexterna: "VAC",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "vac_cierre-periodo",
    loadComponent: () =>
      import("./components/cierre/cierre.component").then(
        (m) => m.CierreComponent
      ),
    data: {
      label: "Cierre",
      icon: "rule_folder",
      urlexterna: "VAC",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
];
